export enum UnitType {
  Acres = 'acre',
  SqMeters = 'm²',
  SqKilometers = 'km²',
  SqMiles = 'mi²',
  Hectares = 'ha',
  SqYards = 'yd²',
  SqFeet = 'ft²',

  Miles = 'milhas',
  Kilometers = 'km',
  Meters = 'm',
  Feet = 'ft',
  Yards = 'jd',

  Degrees = 'Degrees',
  DMS = 'DMS',
}

export const unitTypeToSquareDictionary = new Map<UnitType, UnitType>([
  [UnitType.Miles, UnitType.SqMiles],
  [UnitType.Kilometers, UnitType.SqKilometers],
  [UnitType.Meters, UnitType.SqMeters],
  [UnitType.Feet, UnitType.SqFeet],
  [UnitType.Yards, UnitType.SqYards],
]);

export const unitTypeSuffixDictionary = new Map<UnitType, string>([
  [UnitType.Acres, 'acre'],
  [UnitType.SqMeters, 'm²'],
  [UnitType.SqKilometers, 'km²'],
  [UnitType.SqMiles, 'mi²'],
  [UnitType.Hectares, 'ha'],
  [UnitType.SqYards, 'yd²'],
  [UnitType.SqFeet, 'ft²'],
  [UnitType.Miles, 'milhas'],
  [UnitType.Kilometers, 'km'],
  [UnitType.Meters, 'm'],
  [UnitType.Feet, 'ft'],
  [UnitType.Yards, 'jd'],
  [UnitType.Degrees, 'Degrees'],
  [UnitType.DMS, 'DMS'],
]);
